<div id="chart-wrapper">
  <canvas
    baseChart
    class="chartjs-length"
    [options]="barChartOptions"
    [type]="barChartType"
  >
  </canvas>
</div>
